<script setup lang="ts">
import { Video } from '~/types';
import { onMounted, nextTick } from 'vue';

interface Props {
  video: Video;
}

defineProps<Props>();

onMounted(() => {
  nextTick(() => {
    window.FB.XFBML.parse();
  });
});
</script>

<template>
  <div ref="facebookVideoContainer" class="fb-video-wrapper">
    <div
      ref="player"
      class="fb-video"
      :data-href="video.facebook_url"
      data-autoplay="false"
      data-show-text="false"
    ></div>
  </div>
</template>
